module.exports = __webpack_public_path__ + "img/dataReport_1.79498b7e.png";